import KanbanTaskGroupsAPI from 'dashboard/api/kanbanTaskGroups';

const CL_KEY = 'kanban_checklist_items';

function loadChecklistCache() {
  try {
    return JSON.parse(localStorage.getItem(CL_KEY) || '{}');
  } catch {
    return {};
  }
}

function saveChecklistCache(cache) {
  try {
    localStorage.setItem(CL_KEY, JSON.stringify(cache));
  } catch {
    // ignore quota errors
  }
}

function mergeChecklistFromCache(items) {
  const cache = loadChecklistCache();
  return (items ?? []).map(i => ({
    ...i,
    checklist_items: i.checklist_items?.length
      ? i.checklist_items
      : (cache[i.id] ?? []),
  }));
}

function persistChecklistToCache(items) {
  const cache = loadChecklistCache();
  (items ?? []).forEach(i => {
    if (i.id && i.checklist_items?.length) {
      cache[i.id] = i.checklist_items;
    }
  });
  saveChecklistCache(cache);
}

export default {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await KanbanTaskGroupsAPI.list();
      const groups = (data.data ?? []).map(g => ({
        ...g,
        items: mergeChecklistFromCache(g.items),
      }));
      commit('SET_GROUPS', groups);
      return groups;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit }, payload) {
    commit('SET_UI_FLAG', { isSaving: true });
    try {
      const { data } = await KanbanTaskGroupsAPI.create(payload);
      commit('ADD_GROUP', data.data);
      return data.data;
    } finally {
      commit('SET_UI_FLAG', { isSaving: false });
    }
  },

  async update({ commit }, { id, ...payload }) {
    commit('SET_UI_FLAG', { isSaving: true });
    persistChecklistToCache(payload.items);
    try {
      const { data } = await KanbanTaskGroupsAPI.update(id, payload);
      const serverGroup = data.data;
      const merged = {
        ...serverGroup,
        items: mergeChecklistFromCache(serverGroup.items),
      };
      commit('UPDATE_GROUP', merged);
      return merged;
    } finally {
      commit('SET_UI_FLAG', { isSaving: false });
    }
  },

  async delete({ commit }, id) {
    await KanbanTaskGroupsAPI.destroy(id);
    commit('DELETE_GROUP', id);
  },

  async apply(_, { groupId, cardId }) {
    const { data } = await KanbanTaskGroupsAPI.apply(groupId, cardId);
    return data.data;
  },

  async reorder({ commit }, orderedIds) {
    commit('SET_UI_FLAG', { isSaving: true });
    try {
      await Promise.all(
        orderedIds.map((id, idx) =>
          KanbanTaskGroupsAPI.update(id, { position: idx })
        )
      );
    } finally {
      commit('SET_UI_FLAG', { isSaving: false });
    }
  },
};
